import _ from 'underscore'
import { mapState } from "vuex";
import {getOption,setOption} from '@/utils/ConfigUtils'
import { DYNAMIC_OPTION_TYPES } from '../utils/ConfigUtils'
export default {
  data () {
    return {
      dynamicOptionsTypes: DYNAMIC_OPTION_TYPES
    }
  },
  computed: {
    ...mapState({
      optionsLoaded: state => state.trialOptions.loaded,
      optionsLists: state => state.trialOptions.data
    }),
  },
  methods: {
    /**
     * Function that takes in the inputFields configuration and merge it with values
     * @param {*} config
     * @param {*} values
     */
    // mergeConfigData_OLD (_configItem, _valueItem) {
    //   let configItem = _configItem && JSON.parse(JSON.stringify(_configItem))
    //   let valueItem = _valueItem && JSON.parse(JSON.stringify(_valueItem))
    //   if (valueItem) {
    //     if (valueItem.valuesList) {
    //       configItem.valuesList = valueItem.valuesList
    //     }
    //     configItem.fieldList && configItem.fieldList.forEach(field => {
    //       let fieldValuesItem = valueItem.fieldList.find(el => el.id == field.id)
    //       field.valueList = fieldValuesItem ? fieldValuesItem.valueList : []
    //       if(field.subFieldList && fieldValuesItem.subFieldList){
    //         field.subFieldList && field.subFieldList.forEach(subField => {
    //           let subItem = fieldValuesItem.subFieldList.find(el => el.id == subField.id)
    //           // All values should be linked to the same segmentID
    //           if(subItem) {
    //             let segmentsInvolved = _.unique(subItem.valueList.map(s => s.segmentId))
    //             if(segmentsInvolved.length == 1){
    //               subField.segmentId = segmentsInvolved[0]
    //             }
    //             subField.valueList = subItem.valueList
    //           }
    //         })
    //         // All subfield should be linked to the same segmentID
    //         let fieldSegments = _.unique(field.subFieldList.map(s => s.segmentId))
    //         if(fieldSegments.length == 1){
    //           field.segmentId = fieldSegments[0]
    //         }
    //       }
    //     })
    //   }
    //   return configItem
    // },
    hasLiveValues(optionType,optionId){
      let optArray = getOption(this.trial,optionType)
      if(!optionId){
        return optArray && optArray.length > 0
      } else {
        let candidate = optArray && optArray.find((d)=>d.id===optionId)
        if(candidate) return true
        else return false
      }
    },
    fillWithTemplateData(data){
      console.log("trialConfig > fillWithTemplateData()")
      data = JSON.parse(JSON.stringify(data))
      // return this.mergeViewIntoValues
      // console.log("optionsLsits",this.optionsLists)
      this.dynamicOptionsTypes.map((optionType)=>{
        // (data.cohortGeneration.population[optionType] || []).forEach((value)=>{
        (getOption(data,optionType) || []).forEach((value)=>{
          let template = this.optionsLists[optionType].find((d)=>d.id === value.id)
          if(template) this.mergeViewIntoValues(value,template)
          else console.warn(`WTF!: template not found for ${optionType} - ${value.id}`)
        })
      })
      return data
    },
    mergeViewIntoValues ( _value, _template) {
      if(_value.fields){
        _value.fields.forEach((field,i)=>{
          if(!field.view) field.view = _template.fields[i].view
          if(Array.isArray(field.value)) {
            this.mergeRecursive(field.value, _template.fields[i].value)
          }
        })
      } else {
        if(!_value.view) _value.view = _template.view
      }
      // console.log('after',_value)
    },
    mergeRecursive (value, template) {
      if(!template) return
      if(Array.isArray(template)) {
        value.forEach((subValue,i)=>{
          //CUIDAO!!!! que con los multisegmetns, puede que template solo haya uno, pero muchos values
          this.mergeRecursive(subValue, template.find((t)=>t.id===subValue.id))
        })
      } else if(template.valueType==='parameter') {
        if(!value.view) value.view = template.view
        this.mergeRecursive(value.value, template.value)
      } else if (template.view) {
        if(!value.view) value.view = template.view
      }
    },
    
    // COULD BE in ConfigUTils, no?!
    // mergeConfigData (_configItem, _valueItem) {
    //   let configItem = _configItem && JSON.parse(JSON.stringify(_configItem))
    //   let valueItem = _valueItem && JSON.parse(JSON.stringify(_valueItem))
    //   if (valueItem) {
    //     configItem.fieldList.forEach(fieldConfigItem => {
    //       let fieldValueItem = valueItem.fieldList.find(d => d.id == fieldConfigItem.id)

    //       if(fieldConfigItem.subFieldList){
    //         if (fieldConfigItem.segmentConfig) { // cas 4
    //           // fieldConfigItem.subFieldList.forEach((sf)=>{
    //           //   sf.segmentList = []
    //           //   fieldValueItem.segmentList.forEach((segment) => {
    //           //     let sfSegmentValue = segment.subFieldList.find(d => d.id == sf.id)
    //           //     sf.segmentList.push({segmentId: segment.segmentId, value: sfSegmentValue.value})
    //           //   })
    //           // })
    //           // cas 4 v.1
    //           fieldConfigItem.segmentList = fieldValueItem.segmentList
    //           fieldConfigItem.segmentList.forEach((segment)=> {
    //             segment.subFieldList.forEach((sf) => {
    //               let elem = fieldConfigItem.subFieldList.find( (sfConfig) => sfConfig.id === sf.id)
    //               sf.parameterConfig = elem.parameterConfig
    //               sf.name = elem.name
    //               sf.order = elem.order
    //               sf.description = elem.description
    //             })
    //           })
    //         } else { // cas 2
    //           fieldConfigItem.subFieldList.forEach((sf)=>{
    //             let subFieldValueItem = fieldValueItem.subFieldList.find(d => d.id == sf.id)
    //             sf.value = subFieldValueItem.value
    //           })
    //         }
    //       } else {
    //         if (fieldConfigItem.segmentConfig) { // cas 3
    //           fieldConfigItem.segmentList = fieldValueItem.segmentList
    //           fieldConfigItem.segmentList.forEach((segment)=> {
    //             segment.parameterConfig = fieldConfigItem.parameterConfig
    //             segment.name = fieldConfigItem.name
    //             segment.order = fieldConfigItem.order
    //             segment.description = fieldConfigItem.description
    //           })
    //         } else { // cas 1
    //           fieldConfigItem.value = fieldValueItem.value
    //         }
    //       }
    //     })
    //   }
    //   return configItem
    // },
    
    // extractValues (_mergedConfigAndValues) {
    //   if(Array.isArray(_mergedConfigAndValues)){
    //     return _mergedConfigAndValues.map((o)=>{
    //       return this.extractOptValues(o)
    //     }).filter((d)=>d!==null)
    //   }
    //   else {
    //     return this.extractOptValues(_mergedConfigAndValues)
    //   }
    // },
    
    // extractOptValues (_opt){
    //   if(_opt.fieldList) {
    //     let fieldList = _opt.fieldList.map((field => this.extractFieldValues(field))).filter((d)=>d!==null)
    //     if(fieldList.length>0){
    //       return {
    //         id: _opt.id,
    //         fieldList: fieldList
    //       }
    //     } else {
    //       return null
    //     }
    //   }
    // },
    
    // extractFieldValues (field) {
    //   if(field.segmentList){
    //     return {
    //       id: field.id,
    //       segmentList: field.segmentList.map((s)=>this.extractSegmentValues(s)).filter((d)=>d!==null)
    //     }
    //   } else if(field.subFieldList){
    //     return {
    //       id: field.id,
    //       subFieldList: field.subFieldList.map((sf)=>this.extractSubFieldValues(sf)).filter((d)=>d!==null)
    //     }
    //   } else if(field.value){
    //     return {
    //       id: field.id,
    //       value: field.value
    //     }
    //   } else {
    //     return null
    //   }
    // },
    
    // extractSegmentValues (seg) {
    //   if(seg.subFieldList) {
    //     return {
    //       segmentId: seg.segmentId,
    //       subFieldList: seg.subFieldList.map((sf)=>this.extractSubFieldValues(sf)).filter((d)=>d!==null)
    //     }
    //   } else if(seg.value) {
    //     return {
    //       segmentId: seg.segmentId,
    //       value: seg.value
    //     }
    //   } else {
    //     return null
    //   }
    // },
    // extractSubFieldValues (subField) {
    //   if(subField.value) {
    //     return {
    //       id: subField.id,
    //       value: subField.value
    //     }
    //   } else {
    //     return null
    //   }
    // }
  },
}